import { SingleResponse } from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"
import { RecoveryCodesStatus } from "../../tastyworks/recovery-codes"

export class RecoveryCodesService {
  //@ts-ignore
  private readonly recoveryCodesClient: HttpClient

  constructor(userMeClient: HttpClient) {
    this.recoveryCodesClient = userMeClient.nested("recovery-codes")
  }

  // TODO: KRKC-11 Pass 2 — replace mock with:
  //   this.recoveryCodesClient.show(new RecoveryCodesStatus(), RECOVERY_CODES_STATUS_DESER.update, "")
  // eslint-disable-next-line @typescript-eslint/require-await
  readonly getStatus = async () => {
    const status = new RecoveryCodesStatus()
    status.codesRemaining = 10
    status.totalCodes = 10
    status.generatedAt = new Date("2026-07-10T15:04:49.663Z")
    const response = new SingleResponse<RecoveryCodesStatus>()
    response.data = status
    return response
  }
}
